import {
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  HStack,
  useToast,
  Box,
  Link,
  Text,
  Center,
  Spinner,
  Alert,
  AlertTitle,
  AlertDescription,
  AlertIcon,
} from "@chakra-ui/react";
import AuthBox from "components/elements/AuthBox";
import { AuthHeading } from "components/layout/AuthLayout";
import { useState } from "react";
import { useAuthenticationActions } from "modules/authentication/mutations/authentication-actions";
import { getErrorMessage } from "utils/errorHandler";
import { useAuth } from "modules/authentication/providers/authentication-provider";

export function Register() {
  const toast = useToast();
  const { company } = useAuth();
  const { signUp } = useAuthenticationActions();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  async function handleRegister(ev: React.FormEvent<HTMLFormElement>) {
    ev.preventDefault();
    if (!company) return;
    try {
      await signUp.mutateAsync({
        email,
        lender_company: company.id,
        companyName,
        first_name: firstName,
        last_name: lastName,
      });
      setSuccess(true);
    } catch (err) {
      toast({
        title: "Registration Failed",
        description: getErrorMessage(err),
        status: "error",
      });
    }
  }

  if (!company) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  if (success) {
    return (
      <AuthBox>
        <Alert
          status="success"
          variant="subtle"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          borderRadius="25px"
          height="200px"
        >
          <AlertIcon boxSize="40px" mr={0} />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Verify Email
          </AlertTitle>
          <AlertDescription maxWidth="sm">
            Please click the link we've sent you to verify your email.
          </AlertDescription>
        </Alert>
      </AuthBox>
    );
  }

  return (
    <AuthBox>
      <AuthHeading title="Create Your Account" />
      <Box w="370px">
        <form onSubmit={handleRegister}>
          <HStack spacing="20px" alignItems="top" mt="30px">
            <FormControl>
              <FormLabel variant="onboarding">First Name</FormLabel>
              <Input
                type="text"
                placeholder="John"
                value={firstName}
                onChange={ev => setFirstName(ev.target.value)}
                variant="primary"
              />
            </FormControl>
            <FormControl>
              <FormLabel variant="onboarding">Last Name</FormLabel>
              <Input
                type="text"
                placeholder="Doe"
                value={lastName}
                onChange={ev => setLastName(ev.target.value)}
                variant="primary"
              />
            </FormControl>
          </HStack>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Work Email</FormLabel>
            <Input
              type="email"
              placeholder="john@company.com"
              value={email}
              onChange={ev => setEmail(ev.target.value)}
              variant="primary"
            />
          </FormControl>
          <FormControl mt="16px">
            <FormLabel variant="onboarding">Company Name</FormLabel>
            <Input
              type="text"
              placeholder="Borrower Builder, Inc."
              value={companyName}
              onChange={ev => setCompanyName(ev.target.value)}
              variant="primary"
            />
          </FormControl>
          <VStack>
            <Button
              colorScheme="blue"
              type="submit"
              mt="24px"
              mb="20px"
              px="36px"
              w="100%"
              data-cy="create-account"
              isLoading={signUp.isPending}
            >
              Create Account
            </Button>
            <Text fontSize="16px">
              Already a member?{" "}
              <Link href={`/login/${company.slug}`} color="primary">
                Log in here
              </Link>
            </Text>
          </VStack>
        </form>
      </Box>
    </AuthBox>
  );
}
